import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { BlackList } from '../interfaces/blacklist';
import { AssinaturaPlano } from '../interfaces/assinatura-plano';
import { Observable } from 'rxjs';
import { PageResult } from '../interfaces/page-result';

@Injectable({
  providedIn: "root",
})
export class BlackListService {
  // Gestão de blacklist/planos/contrato fica SEMPRE na central (compartilhada entre empresas).
  readonly url = `https://infokaw.com.br/api/blackList`;
  // Mesma estratégia do NotificacaoService: path local via environment.apiURL. No build intranet
  // vira '/api/blackList' (mesma origem, sem preflight/CORS, o jkaw-api local tem o endpoint);
  // no build cloud/prod environment.apiURL já é 'https://infokaw.com.br/api', então cai na central.
  readonly urlLocal = `${environment.apiURL}/blackList`;

  constructor(private http: HttpClient) {}

  uploadContrato(value: any): Observable<any> {
    return this.http.post(`${this.url}/contrato/upload/v2`, value);
  }

  signContrato(uuid: string): Observable<any> {
    return this.http.get<BlackList>(
      `${this.url}/contrato/sign/v2?uuid=${uuid}`
    );
  }

  getContratoByTipo(codigo: string, tipo: string): Observable<any> {
    return this.http.get<any>(`${this.url}/contrato/v2/${codigo}/${tipo}`);
  }
  saveOrUpdate(blackList: BlackList): Observable<BlackList> {
    const result = this.http.put<BlackList>(`${this.url}`, blackList);
    return result;
  }

  /**
   * Atualiza apenas informações de log de login da BlackList
   * PUT /api/blackList/log
   */
  saveOrUpdateLog(blackList: BlackList, token?: string): Observable<BlackList> {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    // Usa o path local (relativo no intranet) para evitar o preflight CORS bloqueado pela central.
    console.log(`BlackListService - saveOrUpdateLog - URL: ${this.urlLocal}/log`);
    return this.http.post<BlackList>(`${this.urlLocal}/log`, blackList, { headers });
  }


  /**
   * Retorna títulos vencidos há mais de 5 dias para o documento (CNPJ/CPF)
   * GET /api/blackList/titulo/vencidos?cnpjOuCpf=...
   */
  getVencidos(cnpjOuCpf?: string): Observable<any[]> {
    const params = cnpjOuCpf ? `?cnpjOuCpf=${encodeURIComponent(cnpjOuCpf)}` : '';
    return this.http.get<any[]>(`${this.url}/titulo/vencidos${params}`);
  }

  

  getBlackList(id: number): Observable<BlackList> {
    return this.http.get<BlackList>(`${this.url}/?blackListId=${id}`);
  }

  getBlackListPage(
    page?: number,
    size?: number,
    order?: string,
    direction?: string,
    desativado?: boolean
  ): Observable<PageResult<BlackList>> {
    const params: string[] = [];
    if (page !== undefined) params.push(`page=${page}`);
    if (size !== undefined) params.push(`size=${size}`);
    if (order !== undefined) params.push(`order=${order}`);
    if (direction !== undefined) params.push(`direction=${direction}`);
    params.push(`desativado=${desativado ?? false}`);
    const queryString = params.join('&');
    return this.http.get<PageResult<BlackList>>(
      `${this.url}/page/get/?${queryString}`
    );
  }

  getBlackListPageSearch(
    page?: number,
    size?: number,
    search?: string,
    order?: string,
    direction?: string,
    desativado?: boolean
  ): Observable<PageResult<BlackList>> {
    const params: string[] = [];
    if (page !== undefined) params.push(`page=${page}`);
    if (size !== undefined) params.push(`size=${size}`);
    if (search !== undefined && search !== '') params.push(`search=${encodeURIComponent(search)}`);
    if (order !== undefined) params.push(`order=${order}`);
    if (direction !== undefined) params.push(`direction=${direction}`);
    params.push(`desativado=${desativado ?? false}`);
    const queryString = params.join('&');
    console.log(`BlackListService - getBlackListPageSearch - URL: ${this.url}/page/get/?${queryString}`);
    return this.http.get<PageResult<BlackList>>(
      `${this.url}/page/get/?${queryString}`
    );
  }

  listarPlanos(): Observable<AssinaturaPlano[]> {
    return this.http.get<AssinaturaPlano[]>(`${this.url}/plano/lista`);
  }

  salvarPlano(plano: AssinaturaPlano): Observable<AssinaturaPlano> {
    if (plano?.id) {
      return this.http.put<AssinaturaPlano>(`${this.url}/plano`, plano);
    }
    return this.http.post<AssinaturaPlano>(`${this.url}/plano`, plano);
  }

  removerPlano(id: number): Observable<void> {
    return this.http.delete<void>(`${this.url}/plano/${id}`);
  }
}
